import { Reveal } from "./Reveal";
import { Search, Users, Compass } from "lucide-react";

const PILLARS = [
  { icon: Search, label: "Find what you need" },
  { icon: Users, label: "Connect with who can provide it" },
  { icon: Compass, label: "Discover new opportunities" },
];

export const WhatIs = () => (
  <section data-testid="what-is-section" className="relative py-20 lg:py-28 border-t border-white/5">
    <div
      className="absolute inset-0 pointer-events-none"
      style={{ background: "radial-gradient(ellipse 45% 55% at 20% 50%, rgba(0,240,255,0.05), transparent 65%)" }}
    />
    <div className="relative max-w-7xl mx-auto px-6 lg:px-10">
      <Reveal>
        <span className="font-mono-accent text-xs tracking-[0.3em] text-[#00F0FF]" data-testid="what-is-eyebrow">
          /// WHAT IS FINDXCHANGE
        </span>
        <h2 className="mt-6 font-display font-extrabold uppercase text-2xl sm:text-4xl lg:text-5xl leading-[1.05] tracking-tight text-slate-100 max-w-4xl" data-testid="what-is-title">
          One platform to <span className="text-[#00F0FF]">find</span> what you need,{" "}
          <span className="text-[#00F0FF]">connect</span> with who can provide it, and{" "}
          <span className="text-[#00F0FF]">discover</span> new opportunities.
        </h2>
        <p className="mt-6 max-w-2xl text-base sm:text-lg text-slate-400 leading-relaxed" data-testid="what-is-description">
          FINDXCHANGE is the meeting point for people and businesses. Post what you need or what
          you can offer — the network brings the other side to you.
        </p>
      </Reveal>

      <Reveal delay={0.12}>
        <div className="mt-10 flex flex-col sm:flex-row sm:flex-wrap gap-x-10 gap-y-4" data-testid="what-is-pillars">
          {PILLARS.map((p, i) => (
            <div key={p.label} className="flex items-center gap-3" data-testid={`what-is-pillar-${i}`}>
              <p.icon size={16} className="text-[#00F0FF] shrink-0" />
              <span className="font-mono-accent text-[11px] sm:text-xs uppercase tracking-[0.22em] text-slate-300">
                {p.label}
              </span>
            </div>
          ))}
        </div>
      </Reveal>

      <Reveal delay={0.2}>
        <div className="mt-12 flex flex-col sm:flex-row gap-4">
          <a href="/opportunities" data-testid="what-is-find-btn" className="btn-primary">
            Find an Opportunity
          </a>
          <a href="/post?type=need" data-testid="what-is-post-btn" className="btn-ghost">
            Post What You Need
          </a>
        </div>
      </Reveal>
    </div>
  </section>
);
